function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var _ref = /*#__PURE__*/React.createElement("defs", null);
var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Attachment",
  className: "cls-1",
  d: "M13.228,7.5a.811.811,0,0,0-1.144,0L8.226,11.347A3.549,3.549,0,0,1,3.194,6.341L7.324,2.23a2.111,2.111,0,0,1,2.974,0,2.088,2.088,0,0,1,.032,2.927L6.169,9.3a.655.655,0,0,1-.918,0,.641.641,0,0,1,0-.9L9.11,4.547a.81.81,0,0,0,0-1.143.8.8,0,0,0-.573-.239h0a.8.8,0,0,0-.57.235L4.112,7.244a2.261,2.261,0,1,0,3.2,3.2l4.131-4.112a3.7,3.7,0,0,0,0-5.246,3.729,3.729,0,0,0-5.255,0L2.054,5.2A5.156,5.156,0,0,0,5.71,14a5.162,5.162,0,0,0,3.657-1.507l3.86-3.845A.812.812,0,0,0,13.228,7.5Z"
});
var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    id: "BeBold",
    viewBox: "0 0 14 14"
  }, props), _ref, _ref2);
};
export default __webpack_public_path__ + "static/media/attachment.8d43aefa.svg";
export { SvgComponent as ReactComponent };